"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useSlider_1 = __importDefault(require("../useSlider"));
var SliderProgress = function (props) {
    var _a = props.htmlElement, Tag = _a === void 0 ? 'div' : _a, style = props.style, _b = props.indicator, _c = _b === void 0 ? {} : _b, indicatorID = _c.id, indicatorStyle = _c.style, _d = _c.htmlElement, IndicatorTag = _d === void 0 ? 'div' : _d, indicatorRest = __rest(_c, ["id", "style", "htmlElement"]), _e = props.indicatorType, indicatorType = _e === void 0 ? 'position' : _e, rest = __rest(props, ["htmlElement", "style", "indicator", "indicatorType"]);
    var _f = (0, react_1.useState)(undefined), segmentStyle = _f[0], setSegmentStyle = _f[1];
    var _g = (0, useSlider_1.default)(), scrollRatio = _g.scrollRatio, slides = _g.slides, slidesToShow = _g.slidesToShow, setIsPaused = _g.setIsPaused, pauseOnHover = _g.pauseOnHover, scrollOffset = _g.scrollOffset, sliderTrackRef = _g.sliderTrackRef;
    (0, react_1.useEffect)(function () {
        var newSegmentStyle;
        var track = sliderTrackRef.current;
        if (track) {
            newSegmentStyle = {};
            var trackWidth = track.offsetWidth;
            var scrollOffsetRatio = scrollOffset > 0 ? ((trackWidth / scrollOffset) / 100) : 0;
            var segmentWidth = (1 / slides.length) / (1 / slidesToShow) - scrollOffsetRatio;
            if (indicatorType === 'position') {
                newSegmentStyle.width = "".concat(segmentWidth * 100, "%");
                newSegmentStyle.left = "".concat((scrollRatio - (scrollRatio * segmentWidth)) * 100, "%");
            }
            if (indicatorType === 'width') {
                newSegmentStyle.width = "".concat(scrollRatio * 100, "%");
                newSegmentStyle.left = '0px';
            }
            setSegmentStyle(newSegmentStyle);
        }
    }, [
        slides.length,
        indicatorType,
        scrollRatio,
        slidesToShow,
        sliderTrackRef,
        scrollOffset,
    ]);
    return (react_1.default.createElement(Tag, __assign({}, rest, { style: __assign({ position: 'relative' }, style || {}), onMouseEnter: function () {
            if (pauseOnHover)
                setIsPaused(true);
        }, onMouseLeave: function () {
            if (pauseOnHover)
                setIsPaused(false);
        } }),
        react_1.default.createElement(IndicatorTag, __assign({ id: indicatorID }, indicatorRest, { style: __assign(__assign({ position: 'absolute', top: 0, height: '100%' }, segmentStyle || {}), indicatorStyle || {}) }))));
};
exports.default = SliderProgress;
